import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";
import { useFavorites } from "@/hooks/useFavorites";

interface VideoCardProps {
  item: VideoItem;
  showFavorite?: boolean;
}

export default function VideoCard({ item, showFavorite = false }: VideoCardProps) {
  const { isFavorite, toggle } = useFavorites();
  const favorite = isFavorite(item.id);

  const handleFavorite = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    toggle(item.id);
  };

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer"
      title={`${item.title}（${item.year}）`}
    >
      <div className="relative w-full overflow-hidden rounded-lg bg-background-200" style={{ aspectRatio: "3 / 4" }}>
        <img
          src={item.cover}
          alt={`${item.title}封面海报`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-primary-950/0 transition-colors duration-300 group-hover:bg-primary-950/40" />
        <span className="absolute left-2 top-2 rounded-md bg-primary-950/80 px-1.5 py-0.5 text-[11px] font-bold text-accent-300">
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500/90 text-background-50">
            <i className="ri-play-fill text-xl" />
          </span>
        </div>
        {showFavorite && (
          <button
            type="button"
            onClick={handleFavorite}
            aria-label={favorite ? "取消收藏" : "收藏"}
            className={`absolute right-2 top-2 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full transition-colors ${
              favorite ? "bg-accent-500 text-background-50" : "bg-primary-950/60 text-background-50 hover:bg-accent-500"
            }`}
          >
            <i className={`${favorite ? "ri-heart-3-fill" : "ri-heart-3-line"} text-sm`} />
          </button>
        )}
      </div>
      <h3 className="mt-2 line-clamp-1 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
        {item.title}
      </h3>
      <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
        {item.year} · {item.genres[0]} · {item.region}
      </p>
    </Link>
  );
}